import { motion } from "framer-motion";
import { useId } from "react";
type Option = {
  value: string;
  label: string;
};

/** Theme-aware segmented control: works on white, mist, dark and brand fields. */
export function Segmented({
  options,
  value,
  onChange,
  size = "md"
}: {
  options: Option[];
  value: string | null;
  onChange: (v: string) => void;
  size?: "md" | "lg";
}) {
  const id = useId();
  return <div role="tablist" data-noswipe className="inline-flex rounded-full border border-[var(--s-rule)] p-0.5" data-id="element-234" data-mp="1cmypr1x4q7b3">
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} role="tab" aria-selected={active} onClick={() => onChange(o.value)} className={`relative whitespace-nowrap rounded-full font-semibold transition-colors duration-150 ${size === "lg" ? "px-5 py-2 text-[14px] tracking-[0.06em]" : "px-3.5 py-1.5 text-[12.5px]"} ${active ? "text-[var(--s-bg)]" : "text-[var(--s-fg)] opacity-75 hover:opacity-100"}`} data-id="element-235" data-mp="1mly0cq1ggd0q">
            {active && <motion.span layoutId={`seg-${id}`} className="absolute inset-0 rounded-full bg-[var(--s-fg)]" transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-236" data-mp="14anakakual1a" />}
            <span className="relative" data-id="element-237" data-mp="1e7jm6p61bna2">{o.label}</span>
          </button>;
    })}
    </div>;
}